import { useEffect, useState } from 'react';
import { message } from 'antd';
import { Container } from 'types';
import API from '../../API';

interface Filters {}

export const useContainers = (_: Filters) => {
	const [containers, setContainers] = useState<Container[]>();

	useEffect(() => {
		fetchContainers();
	}, []);

	const fetchContainers = async () => {
		try {
			const containers = await API.containers.getAll();

			setContainers(containers);
		} catch (e) {
			console.error(e);
			message.error(`Nie udało się pobrać danych (${e})`);
		}
	};

	return containers;
};
